// Phase computation utility — now consumes backend-provided settings.
// Phases:
//  1: Build Awareness (before phase2_start)
//  2: Live Pitches (phase2_start → phase2_end)
//  3: Final Voting Push (phase2_end → voting_close)
//  4: Voting Closed (voting_close → phase4_end)
//  5: Post-Event Highlights (after phase4_end)

export const DEFAULT_SETTINGS = {
  auto_phase: true,
  phase_override: null,
  phase2_start: "2026-06-16T00:00:00-04:00",
  phase2_end: "2026-06-18T23:59:59-04:00",
  voting_close: "2026-06-22T23:59:59-04:00",
  phase4_end: "2026-07-18T23:59:59-04:00",
  vip_date: "2026-07-17",
  main_date: "2026-07-18",
  section_visibility: { banners: true, sponsors: true, stakes: true, pitches: true, judges: true, highlights: true, forms: true },
  hero_overrides: {},
};

export function getPhase(settings = DEFAULT_SETTINGS, now = new Date()) {
  if (settings.auto_phase === false && settings.phase_override) return Number(settings.phase_override);
  const p2s = new Date(settings.phase2_start);
  const p2e = new Date(settings.phase2_end);
  const vc = new Date(settings.voting_close);
  const p4e = new Date(settings.phase4_end);
  if (now < p2s) return 1;
  if (now >= p2s && now <= p2e) return 2;
  if (now > p2e && now <= vc) return 3;
  if (now > vc && now <= p4e) return 4;
  return 5;
}

export const PITCH_DAYS = ["2026-06-16", "2026-06-17", "2026-06-18"];

function pitchDateTime(dateStr) {
  return new Date(`${dateStr}T19:00:00-04:00`);
}

export function nextPitchSession(now = new Date()) {
  for (const d of PITCH_DAYS) {
    const dt = pitchDateTime(d);
    if (dt > now) return { date: d, datetime: dt };
  }
  return null;
}

export function isPitchLiveNow(now = new Date()) {
  for (const d of PITCH_DAYS) {
    const start = pitchDateTime(d);
    const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
    if (now >= start && now <= end) return { date: d, start, end };
  }
  return null;
}

export function votingDeadlineDate(settings = DEFAULT_SETTINGS) {
  return new Date(settings.voting_close);
}

export function formatPitchDate(dateStr) {
  const d = new Date(`${dateStr}T12:00:00-04:00`);
  return d.toLocaleDateString("en-US", { weekday: "short", month: "long", day: "numeric" });
}

export function buildICS({ title, description, startISO, endISO, location = "Online (Zoom)", url = "" }) {
  const fmt = (iso) => new Date(iso).toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Business Showers//EN",
    "BEGIN:VEVENT",
    `UID:${Date.now()}@businessshowers`,
    `DTSTAMP:${fmt(new Date().toISOString())}`,
    `DTSTART:${fmt(startISO)}`,
    `DTEND:${fmt(endISO)}`,
    `SUMMARY:${title}`,
    `DESCRIPTION:${(description || "").replace(/\n/g, "\\n")}`,
    `LOCATION:${location}`,
    url ? `URL:${url}` : "",
    "END:VEVENT",
    "END:VCALENDAR",
  ].filter(Boolean).join("\r\n");
  return ics;
}

export function downloadICS(filename, ics) {
  const blob = new Blob([ics], { type: "text/calendar" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

// Legacy alias - some components still import this
export const EVENT = {
  pitchDays: PITCH_DAYS,
  mainCelebration: "2026-07-18",
};
